import React, { ReactElement } from 'react';
import { zIndexes } from '../../../styling/zIndexes';
import { RaptorTheme, mainColors } from '../../../styling/theme';
import { NavLink } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import TokenService from '../../../services/token-service';
import { isExternalAdministrator } from '../../../utilities/userRoles';

const useStyles = makeStyles<RaptorTheme>((theme) => ({
  sidebarLeftRoot: {
    width: '18.75rem',
    zIndex: zIndexes.sideBar,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '0.94rem',
    boxShadow: theme.shadows[1],
    height: 'calc(100vh)',
    padding: '0.62rem',
    color: mainColors.mainBlue,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.31rem',
    width: '100%',
  },
  sectionHeading: {
    all: 'unset',
    fontSize: '1.25rem',
    fontWeight: 600,
    padding: '0.31rem 0.62rem',
    borderRadius: '0.25rem',
  },
  sectionItem: {
    all: 'unset',
    fontSize: '1.00rem',
    fontWeight: 400,
    marginLeft: '1.25rem',
    padding: '0.31rem 0.62rem',
    cursor: 'pointer',
    borderRadius: '0.25rem',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  active: {
    backgroundColor: theme.palette.grey[100],
  },
  divider: {
    width: '100%',
    borderTop: `1px solid ${mainColors.mainBlue}`,
  },
  sideBarTitle: {
    fontSize: '1.88rem',
    fontWeight: 600,
    color: mainColors.mainBlue,
    padding: '0 0.62rem',
  },
}));

function SettingsMenu(): ReactElement {
  const classes = useStyles();

  const userDetails = TokenService.getUser();
  const canManageOrganization = isExternalAdministrator(userDetails?.user_type);

  return (
    <div className={classes.sidebarLeftRoot}>
      <div className={classes.sideBarTitle}>Settings</div>
      <div className={classes.divider}></div>
      <div className={classes.section}>
        <div className={classes.sectionHeading}>Account</div>
        <NavLink
          to="/settings/my-account"
          className={({ isActive }) =>
            isActive
              ? `${classes.sectionItem} ${classes.active}`
              : classes.sectionItem
          }
        >
          My Account
        </NavLink>
        {canManageOrganization ? (
          <NavLink
            to="/settings/manage-accounts"
            className={({ isActive }) =>
              isActive
                ? `${classes.sectionItem} ${classes.active}`
                : classes.sectionItem
            }
          >
            Manage Accounts
          </NavLink>
        ) : null}
        {canManageOrganization ? (
          <NavLink
            to="/settings/security-settings"
            className={({ isActive }) =>
              isActive
                ? `${classes.sectionItem} ${classes.active}`
                : classes.sectionItem
            }
          >
            Security Settings
          </NavLink>
        ) : null}
      </div>
      {canManageOrganization ? (
        <div className={classes.section}>
          <div className={classes.sectionHeading}>Audit Log</div>
          <NavLink
            to="/settings/audit-log"
            className={({ isActive }) =>
              isActive
                ? `${classes.sectionItem} ${classes.active}`
                : classes.sectionItem
            }
          >
            Audit Log
          </NavLink>
        </div>
      ) : null}
    </div>
  );
}

export default SettingsMenu;
